import { render, staticRenderFns } from "./toplink.vue?vue&type=template&id=5d821a3a"
import script from "./toplink.vue?vue&type=script&lang=js"
export * from "./toplink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports